<template>
  <div class="home">
    <div class="content" :style="'margin-bottom:' + marginBottom + 'px;'">
      <div class="banner">
        <!-- <cube-slide :data="slideImages" /> -->
        <img src="/static/banner3.jpg" style="width: 100%" />
      </div>
      <div class="grids">
        <icon-grid v-for="(item, index) in options" :key="index" :icon="item.icon" :label="item.label"
          :url="item.url" />
      </div>
      <div class="qrcode">
        <canvas class="qr-canvas" id="qrCanvas"></canvas>
        <div>
          <div class="qr-title">取件专属二维码</div>
          <div class="qr-tips">为了个人取件信息安全，请勿将个人专属二维码转发给他人</div>
        </div>
      </div>
      <!-- <img src="/static/waiting.png" style="width: 100%" /> -->
      <!-- <div class="latest-info-container" v-if="circleInfo" @click="gotoDiscovery">
        <div class="latest-info">
          <div class="latest-title">最新发现</div>
          <div class="latest-tips">
            <i class="iconfont icon-broadcast"></i>
            <div>{{circleInfo}} (⊙ˍ⊙)</div>
            <i class="iconfont icon-jiantou"></i>
          </div>
        </div>
      </div>
      <div class="active" v-if="actives.length" @click="activeDetail">
        <img src="/static/zxzx.jpg" style="width: 66px; height: 66px;">
        <transition name="fade">
          <div class="info">
            <div class="info-title">{{currActive.title}}</div>
            <div class="info-sub">活动时间：{{currActive.timeBegin}} 至 {{currActive.timeEnd}}</div>
          </div>
        </transition>
        <div class="dot">
          <span
            :class="index==activeIndex?'currdot':''"
            v-for="(item, index) in actives"
            :key="index"
          >■</span>
        </div>
      </div>
      <div class="links">
        <div class="shop-active-title">
          <div class="biz-title">
            <i class="iconfont icon-huo huo"></i> 校圆便利服务
          </div>
        </div>
        <div class="link-container link-border">
          <div class="link-item link-item-border-right" @click="goto(1)">
            <img src="/static/circle-2.png" style="width: 100%;">
          </div>
          <div class="link-item" @click="goto(2)">
            <img src="/static/circle-1.png" style="width: 100%;">
          </div>
        </div>
        <div class="link-container">
          <div class="link-item link-item-border-right" @click="goto(3)">
            <img src="/static/circle-3.png" style="width: 100%;">
          </div>
          <div class="link-item" @click="gotoAddSkill">
            <img src="/static/circle-4.png" style="width: 100%;">
          </div>
        </div>
      </div>

      <div class="circle">
        <div class="circle-conditon">
          <div class="slide-box">
            <div
              class="slide-item"
              :class="currType.name==item.name?'slide-item-select':''"
              v-for="(item, index) in circleTypes"
              :key="index"
              @click="slideClick(item)"
            >{{item.name}}</div>
          </div>
          <div class="search">
            <i class="iconfont icon-index-fabu"></i>
          </div>
        </div>
        <div class="circle-content">
          <div v-if="haveData">
            <circle-item
              v-for="item in circleGoods"
              :key="item._id"
              :item="item"
              :token="encodeToken"
            ></circle-item>
          </div>
          <div class="circle-empty" v-else>
            <img src="/static/none-add.png" style="width: 100%;" @click="addCircle">
          </div>
        </div>

        <div
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="isScrollBusy"
          infinite-scroll-distance="30"
        >
          <div align="center" style="margin-top: 10px; padding-bottom: 5px;">
            <cube-loading style="width: 24px;" v-if="isScrollBusy && !isScrollEnd"/>
            <span
              style="color: #999999; font-size: 0.8rem;"
              v-else-if="isScrollEnd && haveData"
            >没有更多了</span>
          </div>
        </div>
      </div> -->

      <!-- <div class="shop-active">
        <div class="shop-active-title">
          <i class="iconfont icon-huo huo"></i> 精品限时折扣
        </div>
        <div class="goods">
          <img src="/static/goods-1.png" style="width: 100%;">
          <div class="goods-title">双芯合并安卓苹果闪电快充 只能断电</div>
          <div class="goods-tag">
            只能断电 | 闪电快充
            <span class="qiang-bnt">立即抢购</span>
          </div>
        </div>
      </div>-->
    </div>

    <tab curr="首页" :token="encodeToken"></tab>
  </div>
</template>

<script>
const wx = require("weixin-js-sdk");
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import Tab from "./Tab";
import IconGrid from "./IconGrid";
import CircleItem from "../common/CircleItem";

export default {
  name: "Home",
  components: {
    Tab,
    IconGrid,
    CircleItem,
  },
  data() {
    return {
      encodeToken: "",
      token: "",
      marginBottom: 0,
      circleInfo: "",
      circleGoods: [],
      haveData: true,
      isScrollBusy: false,
      isScrollEnd: false,
      pageNo: 0,
      pageCount: 0,
      circleTypes: [
        { type: -1, code: -1, name: "全部" },
        { type: 2, code: 10, name: "书籍" },
        { type: 1, code: 10, name: "TA想买" },
        { type: 1, code: 20, name: "TA出售" },
        { type: 1, code: 30, name: "TA想租" },
        { type: 1, code: 40, name: "TA出租" },
        { type: 1, code: 50, name: "TA想借" },
        { type: 1, code: 60, name: "TA出借" },
        { type: 1, code: 70, name: "TA能" },
        { type: 2, code: 20, name: "日常" },
        { type: 2, code: 30, name: "文体" },
        { type: 2, code: 40, name: "穿戴" },
        { type: 2, code: 50, name: "数码" },
        { type: 2, code: 60, name: "代步" },
        { type: 2, code: 0, name: "其他" },
      ],
      queryGoodsType: false,
      queryBizType: false,
      queryTypeValue: null,
      currType: {
        type: -1,
        code: -1,
        name: "全部",
      },
      circleUsers: [1],
      slideImages: [
        {
          // url: '/#/shops',
          image: "static/banner1.jpg",
        },
        {
          // url: '/#/shops',
          image: "static/banner2.jpg",
        },
        {
          // url: '/#/shops',
          image: "static/banner3.jpg",
        },
      ],
      actives: [],
      currActive: {},
      activeIndex: 0,
      options: [],
      currentTab: "推荐",
      tabs: [
        {
          label: "推荐",
        },
        {
          label: "新鲜",
        },
        {
          label: "附近",
        },
      ],
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    sessionStorage.setItem("encodeToken", this.encodeToken);
    sessionStorage.setItem("token", this.token);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    /* 初始化微信分享 */
    let shareTitle =
      '本喵分享了最新动态，精彩校园生活尽在"校圆通"，快进来看看TAヾ(≧O≦)〃喵~'; // 分享标题
    let shareDesc = "专注校园生活，打造校园一站式综合服务平台。"; // 分享描述
    let shareLink = "http://wx.aixyt.com/#/share/home/-1";
    let shareLogo = "http://static.aixyt.com/logo.png";

    let msgShareContent = {
      title: shareTitle, // 分享标题
      desc: shareDesc, // 分享描述
      link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareLogo, // 分享图标
      success: () => {
        // 设置成功
      },
    };
    let tlShareContent = {
      title: shareTitle, // 分享标题
      link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareLogo, // 分享图标
      success: () => {
        // 设置成功
      },
    };
    let url = window.location.href;
    let params = {
      url: url,
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then((res) => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
        ];
        wx.config(jsConfig);
      })
      .catch((err) => {
        console.log(err);
      });

    wx.ready(function () {
      wx.updateAppMessageShareData(msgShareContent);
      wx.updateTimelineShareData(tlShareContent);
      wx.onMenuShareAppMessage(msgShareContent);
      wx.onMenuShareTimeline(tlShareContent);
    });
    /* 微信分享结束 */

    // 获取最新发现信息
    axios
      .get("/api/circle/latestInfo")
      .then((res) => {
        this.circleInfo = res.data.data;
      })
      .catch((err) => {
        console.log(err);
      });

    if (
      !this.$store.state.User ||
      !this.$store.state.User.userInfo ||
      !this.$store.state.User.userInfo._id
    ) {
      // 根据token查找微信用户信息
      let loading = weui.loading("获取用户信息", {
        className: "custom-classname",
      });

      axios
        .get("/api/user/wxuserInfo")
        .then((res) => {
          loading.hide(function () { });
          if (res.data.success) {
            this.$store.commit("User/add", res.data.data);

            // 根据用户ID 和 用户电话生成二维码
            let qrContent = {
              _id: res.data.data._id,
              phone: res.data.data.phoneMain
            };
            let canvas = document.getElementById("qrCanvas");
            QRCode.toCanvas(canvas, JSON.stringify(qrContent), function (error) {
              if (error) {
                weui.alert(error);
              }
            });

            if (res.data.data.worksite) {
              // 获取活动列表
              axios
                .get("/api/active/list/1/" + res.data.data.worksite._id)
                .then((aRes) => {
                  if (aRes.data.success) {
                    if (aRes.data.data.length > 0) {
                      this.actives = aRes.data.data;
                      this.currActive = this.actives[this.activeIndex];
                      this.currActive.timeBegin = moment(
                        this.currActive.timeBegin
                      ).format("YYYY-MM-DD");
                      this.currActive.timeEnd = moment(
                        this.currActive.timeEnd
                      ).format("YYYY-MM-DD");

                      if (this.actives.length > 1) {
                        setInterval(() => {
                          if (this.activeIndex < this.actives.length - 1) {
                            this.activeIndex++;
                          } else {
                            this.activeIndex = 0;
                          }

                          this.currActive = this.actives[this.activeIndex];
                          this.currActive.timeBegin = moment(
                            this.currActive.timeBegin
                          ).format("YYYY-MM-DD");
                          this.currActive.timeEnd = moment(
                            this.currActive.timeEnd
                          ).format("YYYY-MM-DD");
                        }, 6000);
                      }
                    }
                  }
                })
                .catch((aErr) => {
                  console.log("获取最新活动失败");
                });
            }
            // 获取集市列表
          } else {
            weui.alert("获取用户信息失败");
          }
        })
        .catch((err) => {
          console.log(err);
          loading.hide(function () { });
          weui.alert("获取用户信息失败");
        });
    } else if (this.$store.state.User.userInfo.worksite) {
      // 获取活动列表
      axios
        .get(
          "/api/active/list/1/" + this.$store.state.User.userInfo.worksite._id
        )
        .then((aRes) => {
          if (aRes.data.success) {
            if (aRes.data.data.length > 0) {
              this.actives = aRes.data.data;
              this.currActive = this.actives[this.activeIndex];
              this.currActive.timeBegin = moment(
                this.currActive.timeBegin
              ).format("YYYY-MM-DD");
              this.currActive.timeEnd = moment(this.currActive.timeEnd).format(
                "YYYY-MM-DD"
              );

              if (this.actives.length > 1) {
                setInterval(() => {
                  if (this.activeIndex < this.actives.length - 1) {
                    this.activeIndex++;
                  } else {
                    this.activeIndex = 0;
                  }

                  this.currActive = this.actives[this.activeIndex];
                  this.currActive.timeBegin = moment(
                    this.currActive.timeBegin
                  ).format("YYYY-MM-DD");
                  this.currActive.timeEnd = moment(
                    this.currActive.timeEnd
                  ).format("YYYY-MM-DD");
                }, 6000);
              }
            }
          }
        })
        .catch((aErr) => {
          console.log("获取最新活动失败");
        });
    }

    this.options = [
      {
        label: "我要取件",
        icon: "/static/index-qujian.png",
        url: "/expressTotakeList/ing/" + this.encodeToken,
      },
      {
        label: "我要寄件",
        icon: "/static/index-jijian.png",
        url: "/expressTotakein/" + this.encodeToken,
      },
      {
        label: "寄件记录",
        icon: "/static/index-jjlist.png",
        url: "/expressSendList/ing/" + this.encodeToken,
      },
      {
        label: "加入跑腿",
        icon: "/static/index-jiaru.png",
        url: "/paotuiApply/" + this.encodeToken,
      },
      {
        label: "跑腿接单",
        icon: "/static/index-qiangdan.png",
        url: "/robbing/" + this.encodeToken,
      },
      {
        label: "我领取的",
        icon: "/static/index-paisong.png",
        url: "/robbingList/2/ing/" + this.encodeToken,
      },
      {
        label: "我发布的",
        icon: "/static/index-fabu.png",
        url: "/robbingList/1/ing/" + this.encodeToken,
      },
      {
        label: "新手指引",
        icon: "/static/index-zhiyin.png",
        url: "/help",
      },
    ];
  },
  methods: {
    gotoDiscovery() {
      this.$router.push("/circleDiscovery/" + this.encodeToken);
    },
    activeDetail() {
      this.$router.push(
        "/active/" + this.currActive._id + "/" + this.encodeToken
      );
    },
    slideClick(item) {
      if (this.currType.name != item.name) {
        this.currType = item;
        if (item.type == -1) {
          this.queryGoodsType = false;
          this.queryBizType = false;
        } else if (item.type == 1) {
          this.queryBizType = true;
          this.queryGoodsType = false;
          this.queryTypeValue = item.code;
        } else if (item.type == 2) {
          this.queryBizType = false;
          this.queryGoodsType = true;
          this.queryTypeValue = item.code;
        }

        this.circleGoods = [];
        this.pageNo = 0;
        this.pageCount = 0;
        this.isScrollEnd = false;
        this.haveData = true;
        this.loadMore();
      }
    },
    addCircle() {
      this.$router.push("/circleType/-1/" + this.encodeToken);
    },
    goto(bizType) {
      this.$router.push("/circleType/" + bizType + "/" + this.encodeToken);
    },
    gotoAddSkill() {
      this.$router.push("/circleEdit/70/-1/-1/" + this.encodeToken);
    },
    loadMore() {
      if (this.isScrollEnd || this.isScrollBusy) {
        return;
      }
      this.isScrollBusy = true;
      this.pageNo = this.pageNo + 1;
      let params = {
        pageNo: this.pageNo,
      };
      if (this.queryGoodsType && this.queryTypeValue) {
        params.goodsType = this.queryTypeValue;
      } else if (this.queryBizType && this.queryTypeValue) {
        params.bizType = this.queryTypeValue;
      }
      setTimeout(() => {
        axios
          .get("/api/circle/paging", { params })
          .then((res) => {
            this.isScrollBusy = false;
            if (res.data.success) {
              this.pageCount = res.data.data.pageCount;
              if (this.pageCount > 0) {
                this.haveData = true;
              } else {
                this.haveData = false;
              }

              if (res.data.data.pageNumber >= this.pageCount) {
                this.isScrollEnd = true;
              } else {
                this.isScrollEnd = false;
              }

              this.circleGoods = this.circleGoods.concat(res.data.data.results);
            } else {
              weui.topTips("获取圈子列表出错", 1500);
            }
          })
          .catch((err) => {
            this.isScrollBusy = false;
            console.log(err);
            weui.topTips("获取圈子列表出错", 1500);
          });
      }, 500);
    },
  },
  mounted() {
    this.loadMore();
    this.marginBottom =
      document.getElementsByClassName("weui-tabbar")[0].offsetHeight + 1;
  },
};
</script>

<style>
.home .cube-slide-item img {
  width: 100%;
}
</style>

<style scoped>
.content {
  margin-bottom: 54px;
}

div.tab {
  position: fixed;
  bottom: 0px;
  width: 100%;
}

.grids {
  display: flex;
  flex-wrap: wrap;
  padding-top: 1rem;
  box-shadow: 0 0 15px #cccccc;
}

.latest-info-container {
  position: relative;
}

.latest-dot {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  left: 5px;
  top: 4px;
}

.latest-info {
  margin: 5px auto;
  box-shadow: 0 0 15px #cccccc;
  display: flex;
}

.latest-title {
  background-color: #fea100;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: bold;
  width: 66px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.latest-tips {
  flex: 1;
  display: flex;
  align-items: center;
}

.icon-broadcast {
  margin-left: 10px;
  margin-right: 4px;
  color: red;
}

.latest-tips div {
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-wrap: break-word;
}

.icon-jiantou {
  margin-left: 0px;
  margin-right: 10px;
  color: #fea100;
}

.active {
  margin: 5px auto;
  box-shadow: 0 0 15px #cccccc;
  display: flex;
  height: 66px;
  overflow: hidden;
  position: relative;
}

.dot {
  position: absolute;
  top: 0px;
  right: 5px;
}

.dot span {
  font-size: 1px;
  font-weight: bold;
  padding-left: 2px;
}

.currdot {
  color: #85817d;
}

.info {
  flex: 1;
  padding-top: 10px;
  padding-left: 10px;
}

.info-title {
  font-size: 16px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-wrap: break-word;
  height: 24px;
}

.info-sub {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.shop-active {
  margin-top: 5px;
  box-shadow: 0 0 15px #cccccc;
  overflow: hidden;
  position: relative;
}

.shop-active-tag {
  width: 4px;
  border-radius: 2px;
  background-color: red;
}

.huo {
  color: red;
  font-size: 18px;
}

.shop-active-title {
  height: 36px;
  line-height: 36px;
  margin-left: 15px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
}

.biz-title {
  flex: 1;
  font-weight: bold;
}

.biz-user {
  margin-top: 8px;
}

.biz-user img {
  position: absolute;
}

.user-header {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #fea100;
}

.goods {
  margin-bottom: 10px;
}

.goods:last-child {
  margin-bottom: 0px;
  padding-bottom: 5px;
}

.goods-title {
  margin: 5px 0px 0px 10px;
  font-size: 1.2rem;
}

.goods-tag {
  margin: 0px 0px 5px 10px;
  color: #ccc;
  position: relative;
}

.qiang-bnt {
  background-color: red;
  color: #fff;
  padding: 2px 10px;
  border-radius: 10px;
  position: absolute;
  right: 10px;
  bottom: 0px;
}

.grids>div {
  width: 25%;
}

.links {
  margin: 5px auto;
  box-shadow: 0 0 15px #cccccc;
}

.link-container {
  display: flex;
}

.link-border {
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}

.link-item {
  flex: 1;
  padding: 15px;
}

.link-item-border-right {
  border-right: 1px solid #efefef;
}

.row1,
.row2 {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.5rem;
}

.row2>div {
  width: 100px;
}

.row1>div {
  width: 150px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.circle {
  margin-top: 5px;
  box-shadow: 0 0 15px #bdccd4;
  position: relative;
}

.circle-conditon {
  display: flex;
}

.circle-content {
  border-top: 1px solid #bdccd4;
}

.circle-empty {
  padding: 50px;
}

.slide-box {
  flex: 1;
  padding: 8px;
  display: -webkit-box;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 5px;
}

.slide-item {
  font-size: 14px;
  margin-right: 20px;
}

.slide-item-select {
  font-weight: bold;
  color: red;
}

.slide-item:first-child {
  padding-left: 8px;
}

.slide-item:last-child {
  padding-right: 8px;
}

.search {
  font-size: 22px;
  font-weight: bold;
  width: 40px;
  text-align: center;
  color: #fea100;
}

.search i {
  font-size: 20px;
}

.qrcode {
  margin-top: 30px;
  text-align: center;
  padding-bottom: 30px;
}

.qr-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #67C23A;
}

.qr-tips {
  color: #F56C6C;
}

.qr-canvas {
  height: 200px !important;
  width: 200px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/home/Home.vue